import React from "react";
import Helmet from "react-helmet";

import "./Contact.css";

const Contact = () => {
  return (
    <div className="contact">
      <Helmet title="Contact Fit My Kid" />
      <p>Is there a brand we missed?</p>
      <p>Are we showing an incorrect size?</p>
      <p>Do you have a recommendation on how we can improve www.fitmykid.com?</p>

      <p>Please feel free to drop us a line at <a href="mailto:info@fitmykid.com">info@fitmykid.com</a></p>
    </div>
  );
};

export default Contact;



/** WEBPACK FOOTER **
 ** ./src/components/Contact/Contact.js
 **/